<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M6.772 16.971c-2.41-2.547-3.022-4.028-3.022-6.747C3.75 5.406 7.443 1.5 12 1.5s8.25 3.906 8.25 8.724c0 2.717-.819 4.418-3.018 6.744L12.001 22.5l-5.229-5.529z"/>
  <path stroke="#000" d="M12 12.7c1.519 0 2.75-1.253 2.75-2.8 0-1.546-1.231-2.8-2.75-2.8S9.25 8.354 9.25 9.9c0 1.547 1.231 2.8 2.75 2.8z" clip-rule="evenodd"/>
</svg>
